<template>
  <div
    class="modal-content"
    :style="{ 'min-height': $store.state.screenHeight - 100 + 'px' }"
  >
    <div
      class="modal-header"
      v-if="$store.state.receive_show === false"
    >
      <h5
        class="modal-title"
        id="ToolModalTitle"
      >รายการเงินเชื่อ</h5>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        @click="getCustomer()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div
      class="modal-body row"
      v-if="$store.state.receive_show === false"
      style="font-size: 20px;"
    >
      <div class="col-8">
        <div class="row mb-2">
          <div class="col-sm-6 text-right row">
            <div class="col-3 pt-1">ลูกค้า</div>
            <div class="col-9">
              <multiselect
                v-model="customer"
                :options="options"
                placeholder="เลือกลูกค้า.."
                track-by="arCode"
                :custom-label="customSearch"
                @keyup.enter="PaymentProcessCard"
              ></multiselect>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="input-group mb-3">
              <input
                type="text"
                class="form-control"
                v-model="search"
                @keyup="CheckSearch"
                @keyup.enter="onChange(1); getBillAll();"
                placeholder="เลขที่เอกสาร...."
              >
              <div class="input-group-append">
                <button
                  class="btn btn-primary"
                  @click="onChange(1); getBillAll();"
                  type="button"
                ><i class="fas fa-search"></i> ค้นหา</button>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-sm">
            <thead class="thead-dark">
              <tr class="text-center">
                <th
                  scope="col"
                  style="width: 5%;"
                >#</th>
                <th
                  scope="col"
                  style="width: 25%;"
                >เลขที่บิล</th>
                <th
                  scope="col"
                  style="width: 15%;"
                >วันที่</th>
                <th
                  scope="col"
                  style="width: 20%;"
                >ชื่อลูกค้า</th>
                <th
                  scope="col"
                  style="width: 15%;"
                >ราคารวม</th>
                <th
                  scope="col"
                  style="width: 15%;"
                >ชำระ</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(b, i) in paginate"
                :key="'bill' + i"
              >
                <th
                  scope="row"
                  class="text-center pb-0"
                >
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :value="b"
                      v-model="data_select"
                      @change="calTotalAmount(); b.pay_amount = b.total_amount"
                      :id="'defaultCheck' + i"
                    >
                    <label
                      class="form-check-label"
                      :for="'defaultCheck' + i"
                    >
                    </label>
                  </div>
                </th>
                <td class="text-center pb-0">
                  {{ b.doc_no }}
                </td>
                <td class="text-center pb-0">
                  {{ dateFormatDMY(b.doc_date) }}
                </td>
                <td class="text-left pb-0">
                  {{b.ar_name }}
                  <br>
                  <span style="font-size: 16px;">
                    หมายเหตุ: {{ b.description || '-'}}
                  </span>
                </td>
                <td class="text-right pb-0">
                  {{ numberFormatDecimal(b.total_amount) }}
                </td>
                <td class="text-right pb-0">
                  <input
                    type="number"
                    :disabled="checkDataSelect(b.doc_no) < 0"
                    @change="calTotalAmount(); checkAmout(i)"
                    class="form-control text-right"
                    v-model="b.pay_amount"
                  >
                </td>
              </tr>
              <tr v-if="paginate.length < 1">
                <th
                  scope="row"
                  colspan="5"
                  class="text-center"
                >ไม่มีข้อมูล</th>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          id="components-pagination-demo-mini"
          class="d-flex justify-content-end mb-3 mr-2"
          v-if="bill_data.length > items_perpage"
        >
          <a-pagination
            size="large"
            :total="bill_data.length"
            :itemRender="itemRender"
            @change="onChange"
            v-model="currentPage"
          />
        </div>
      </div>
      <div class="col-4">
        <div class="row">
          <div class="col-12 text-left">ค้างชำระ</div>
          <div
            class="col-12 text-right pt-0"
            style="font-size: 70px; line-height: 60px;"
          >{{ numberFormat(total_amount) }}</div>
        </div>
        <div class="row">
          <div class="col-12 text-left">ยอดชำระ</div>
          <div class="col-12"><input
              type="number"
              v-model="payment_amount"
              @click="payment_amount = ''"
              id="amount_pay"
              class="form-control pt-3 text-right"
              style="font-size: 70px; height: 67px;"
            ></div>
        </div>
        <div
          class="row mt-2"
          style="padding-left: 11px;"
        >
          <button
            type="button"
            class="btn-lg btn-outline-danger m-1 mr-0 p-0"
            style="width: 30%; font-size: 35px;"
            @click="addKey(1)"
          >1</button>
          <button
            type="button"
            class="btn-lg btn-outline-danger m-1 mr-0 p-0"
            style="width: 30%; font-size: 35px;"
            @click="addKey(2)"
          >2</button>
          <button
            type="button"
            class="btn-lg btn-outline-danger m-1"
            style="width: 30%; font-size: 35px;"
            @click="addKey(3)"
          >3</button>
          <button
            type="button"
            class="btn-lg btn-outline-danger m-1 mr-0 p-0"
            style="width: 30%; font-size: 35px;"
            @click="addKey(4)"
          >4</button>
          <button
            type="button"
            class="btn-lg btn-outline-danger m-1 mr-0 p-0"
            style="width: 30%; font-size: 35px;"
            @click="addKey(5)"
          >5</button>
          <button
            type="button"
            class="btn-lg btn-outline-danger m-1"
            style="width: 30%; font-size: 35px;"
            @click="addKey(6)"
          >6</button>
          <button
            type="button"
            class="btn-lg btn-outline-danger m-1 mr-0 p-0"
            style="width: 30%; font-size: 35px;"
            @click="addKey(7)"
          >7</button>
          <button
            type="button"
            class="btn-lg btn-outline-danger m-1 mr-0 p-0"
            style="width: 30%; font-size: 35px;"
            @click="addKey(8)"
          >8</button>
          <button
            type="button"
            class="btn-lg btn-outline-danger m-1"
            style="width: 30%; font-size: 35px;"
            @click="addKey(9)"
          >9</button>
          <button
            type="button"
            class="btn-lg btn-outline-danger m-1 mr-0"
            style="width: 62%; font-size: 35px;"
            @click="addKey(0)"
          >0</button>
          <button
            type="button"
            class="btn-lg btn-outline-danger m-1"
            style="width: 30%; font-size: 35px;"
            @click="removeKey"
          ><i class="fas fa-backspace"></i></button>
        </div>
      </div>
    </div>
    <div
      class="modal-footer"
      v-if="$store.state.receive_show === false"
    >
      <div
        class="btn-group btn-group-lg"
        role="group"
        style="width: 100%"
      >
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="getCustomer()"
        >
          ยกเลิก
        </button>
        <button
          type="button"
          class="btn btn-info"
          data-dismiss="modal"
          @click="$store.state.receive_show = true"
        >
          ใบเสร็จรับเงิน
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="checkOut(1)"
        >เงินโอน</button>
        <button
          type="button"
          class="btn btn-success"
          @click="checkOut(0)"
        >เงินสด</button>
      </div>
    </div>
    <ReceiptList v-if="$store.state.receive_show === true" />
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import api from '../../services/service_pos'
import apiCus from '../../services/service_customer'
import $ from 'jquery'
import Multiselect from 'vue-multiselect'
import Swal from 'sweetalert2'
import ReceiptList from './receipt_list'

export default {
  props: ['tool'],
  components: {
    Multiselect,
    ReceiptList
  },
  data () {
    return {
      bill_data: [],
      hostshift: '',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      payment_amount: '0',
      total_amount: 0,
      data_select: [],
      customer: [],
      options: []
    }
  },
  created () {
    this.checkUser()
    if (sessionStorage.hostshift) {
      this.hostshift = JSON.parse(sessionStorage.hostshift)
      this.getCustomer()
      this.$store.state.receive_show = false
    } else {
      this.$router.push('/')
    }
  },
  computed: {
    paginate: function () {
      this.totalItem = this.bill_data.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.bill_data.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    checkDataSelect (docNo) {
      return this.data_select.findIndex(x => x.doc_no === docNo)
    },
    customSearch ({ arCode, cusName }) {
      return `${arCode}: [${cusName}]`
    },
    checkAmout (index) {
      if (this.paginate[index].pay_amount > this.paginate[index].total_amount || this.paginate[index].pay_amount < 0) {
        this.paginate[index].pay_amount = this.paginate[index].total_amount
      }
    },
    CheckSearch () {
      if (this.search === '') {
        this.onChange(1)
        this.getBillAll()
      }
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    getBillAll () {
      this.$store.commit('Loading')
      var obj = {
        'ar_code': this.customer.arCode,
        'keyword': this.search
      }
      api.billCreditList(
        this.REST_URL,
        obj,
        this.header,
        result => {
          if (result.response === 'success') {
            this.bill_data = result.data
            this.data_select = []
            this.bill_data.forEach(val => {
              val['pay_amount'] = val['total_amount']
            })
            this.calTotalAmount()
          } else {
            this.$notification['warning']({
              message: 'เปิดการขายไม่ได้',
              description: result.message
            })
          }
          this.$store.commit('Loading')
          $('body').on('hidden.bs.modal', '.modal', function () {
            $(this).removeData('bs.modal')
          })
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    addKey (str) {
      if (this.payment_amount.length < 8 || this.payment_amount.length === undefined) {
        if (this.payment_amount === '0') {
          this.payment_amount = ''
        } else {
          this.payment_amount = this.payment_amount.toString()
        }
        this.payment_amount += str
      }
    },
    removeKey () {
      if (this.payment_amount.length > 0) {
        this.payment_amount = this.payment_amount.substring((this.payment_amount.length - 1), 0)
        if (this.payment_amount.length === 0) {
          this.payment_amount = '0'
        }
      }
    },
    calTotalAmount () {
      this.total_amount = 0
      this.data_select.forEach(val => {
        this.total_amount += parseFloat(val['pay_amount'])
      })
    },
    checkOut (type) {
      var arCode = ''
      if (this.customer.arCode === undefined) {
        arCode = this.data_select[0].ar_code
      } else {
        arCode = this.customer.arCode
      }
      var obj = {
        'ar_code': arCode,
        'sum_of_invoice': parseFloat(this.total_amount),
        'sum_of_credit_note': 0,
        'before_tax_amount': parseFloat(this.total_amount),
        'tax_amount': 0,
        'total_amount': parseFloat(this.total_amount),
        'discount_amount': 0,
        'sum_cash_amount': 0,
        'sum_credit_amount': 0,
        'sum_chq_amount': 0,
        'sum_bank_amount': 0,
        'sum_promt_pay_amount': 0,
        'description': '',
        'other_income': 0,
        'other_expense': 0,
        'is_confirm': 0,
        'is_cancel': 0,
        'company_id': this.$store.state.user.company_id,
        'subs': []
      }
      this.data_select.forEach(val => {
        obj.subs.push({
          'inv_no': val['doc_no'],
          'inv_date': this.dateFormatDMY2(val['doc_date']),
          'inv_balance': val['total_amount'],
          'pay_amount': val['pay_amount']
        })
      })
      switch (type) {
        case 0:
          if (parseFloat(this.payment_amount) >= parseFloat(this.total_amount)) {
            // obj.sum_cash_amount = parseFloat(this.payment_amount)
            obj.sum_cash_amount = parseFloat(this.total_amount)
            this.PaymentCredit(obj)
          } else {
            Swal.fire(
              'ชำระเงินไม่สมบูรณ์',
              'ยอดรับชำระน้อยเกินไป',
              'warning'
            )
          }
          break
        case 1:
          if (parseFloat(this.payment_amount) === parseFloat(this.total_amount)) {
            // obj.sum_bank_amount = parseFloat(this.payment_amount)
            obj.sum_bank_amount = parseFloat(this.total_amount)
            this.PaymentCredit(obj)
          } else {
            Swal.fire(
              'ชำระเงินไม่สมบูรณ์',
              'ยอดรับชำระต้องเท่ากับยอดค้างชำระ',
              'warning'
            )
          }
          break
      }
    },
    getCustomer () {
      this.$store.commit('Loading')
      let body = {
        'keyword': '',
        'limit': 1000000,
        'status': 1
      }
      apiCus.listAll(this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            this.options = []
            result.data.forEach(val => {
              this.options.push({
                arCode: val['code'],
                cusName: val['name']
              })
            })
            // this.customer.arCode = result.data[0].code
            this.payment_amount = '0'
            this.getBillAll()
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description: result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    handleChange (value) {
      this.customer = value
      this.getBillAll()
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    PaymentCredit (obj) {
      let changeAmount = this.payment_amount - this.total_amount
      obj.shift_id = parseInt(this.hostshift.id)
      if (parseFloat(changeAmount) >= 0) {
        this.$store.commit('Loading')
        api.payBillCredit(this.REST_URL,
          obj,
          this.header,
          result => {
            if (result.response === 'success') {
              this.getBillAll()
              this.payment_amount = '0'
              this.total_amount = 0
              $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal')
              })
              this.openCashBox(this.hostshift)
              if (parseFloat(changeAmount) >= 1) {
                Swal.fire({
                  title: 'ชำระเงินสำเร็จ',
                  html: '<p class="swal-change-amount">กรุณาทอนเงินจำนวน <span class="swal-change-amount-num">' + this.numberFormat(changeAmount) + '</span> บาท</p>',
                  icon: 'success',
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'ปิดหน้าต่าง'
                })
              } else {
                Swal.fire(
                  'ใบเสร็จรับชำระ',
                  'ใบเสร็จรับเงิน เลขที่ ' + result.data.doc_no,
                  'success'
                )
              }
              $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal')
              })
            } else {
              this.$notification['warning']({
                message: 'สร้างใบเสร็จไม่ได้',
                description: result.message
              })
              $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal')
              })
            }
            this.$store.commit('Loading')
          },
          error => {
            Swal.fire(
              'สร้างใบเสร็จไม่ได้',
              error.message,
              'warning'
            )
            this.$store.commit('Loading')
            $('body').on('hidden.bs.modal', '.modal', function () {
              console.clear()
              $(this).removeData('bs.modal')
            })
          }
        )
      } else {
        Swal.fire(
          'ชำระเงินไม่สมบูรณ์',
          'ยอดรับชำระน้อยเกินไป',
          'warning'
        )
      }
    },
    printBill (docNo) {
      this.$store.commit('Loading')
      var obj = {
        'printer_port': this.hostshift.printer_port,
        'doc_no': docNo
      }
      api.printPayBillCredit(this.REST_URL,
        obj,
        this.header,
        result => {
          if (result.response === 'success') {
            this.$notification['success']({
              message: 'พิมพ์ใบเสร็จสำเร็จ',
              description: result.message
            })
            $('body').on('hidden.bs.modal', '.modal', function () {
              console.clear()
              $(this).removeData('bs.modal')
            })
            this.$store.commit('Loading')
          } else {
            this.$notification['warning']({
              message: 'พิมพ์ใบเสร็จไม่ได้',
              description: result.message
            })
            this.$store.commit('Loading')
            $('body').on('hidden.bs.modal', '.modal', function () {
              console.clear()
              $(this).removeData('bs.modal')
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
          $('body').on('hidden.bs.modal', '.modal', function () {
            console.clear()
            $(this).removeData('bs.modal')
          })
        }
      )
    }
  },
  mounted () {
    $('#ToolModal').on(
      'show.bs.modal',
      function () {
        this.search = ''
        this.getBillAll()
        this.getCustomer()
        this.payment_amount = 0
        this.customer = ''
        this.$store.state.receive_show = false
      }.bind(this)
    )
    $('#ToolModal').on(
      'hidden.bs.modal',
      function () {
        this.payment_amount = 0
        this.customer = ''
        this.search = ''
        this.getBillAll()
        this.getCustomer()
        this.$store.state.receive_show = false
      }.bind(this)
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pos/creditlist_pay.vue